import './bootstrap/bootstrap'

// shido plugins
import dimentions from '../../../node_modules/shido.dimentions.js/src/dimentions.js'
import forms from '../../../node_modules/shido.forms.js/src/forms.js'
import regular from '../../../node_modules/shido.regular.js/src/regular.js'
import proportional from '../../../node_modules/shido.proportional.js/src/proportional.js'

// app
// require('../../../node_modules/...')
import 'alpinejs'
require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js')
import formsHack from '../js/components/forms'

import alert from './components/alerts'
import Tippy, {TippyHTML} from './components/tippy'
import flatpickrInput from './components/flatpickr'
import seeMore from './components/see-more'
import collapse from './components/collapse'
import CropImage from './components/croppie'
import backBtn from './components/back-btn'
import tutorials from './components/tutorials'
import modals from './components/modals'

// Initializers
const docReady = () => {
  new dimentions().init()
  new alert().session()
  new alert().confirm()
  new forms().init()
  new regular().init()
  new proportional().init()
  new collapse().init()

  formsHack()

  new flatpickrInput().init()
  Tippy()
  TippyHTML()
  seeMore()
  CropImage()
  backBtn()

  const revalidateForms = () => {
    setTimeout(() => {
      new forms().process('input-field')
    }, 50)
  }

  app.alert = new alert()
  app.revalidateForms = revalidateForms

  const btnsSubmit = document.querySelectorAll('[type=submit]')

  btnsSubmit.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      btn.innerHTML = 'Espera por favor...'
    })
  })

}

const winLoad = () => {
  tutorials()
  modals()
}

const docReadyWinload = () => {
  // ...
}

// ---
// [IMPORTANT] Do not change or add anything!
document.addEventListener('DOMContentLoaded', () => {
  docReady()
  docReadyWinload()
}, false)
window.addEventListener('load', () => {
  winLoad()
  docReadyWinload()
}, false )
// ---
// ---
